import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import StacksMap from "../components/StacksMap";
import StackStations from "../components/StackStations";
import { fetchStacks } from "../store/stacks";

const StackPayesh = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      dispatch(fetchStacks());
    };

    fetchData();

    const intervalId = setInterval(fetchData, 900000); // 900000 ms = 15 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [dispatch]);

  return (
    <div>
      <StacksMap />
      <StackStations />
    </div>
  );
};

export default StackPayesh;
